const Key = "checkout-auth-intent";

export const setCheckoutAuthIntent = (): void => {
  sessionStorage.setItem(Key, "1");
};

export const consumeCheckoutAuthIntent = (): boolean => {
  const wasSet = sessionStorage.getItem(Key) !== null;
  sessionStorage.removeItem(Key);
  return wasSet;
};
